import { Trans } from '@lingui/react/macro'
import { Button, Card, Group, List, Stack, Text, Title } from '@mantine/core'
import { IconHome, IconSparkles } from '@tabler/icons-react'

interface FrontpageWelcomeProps {
  onAddPropertyClick: () => void
}

export function FrontpageWelcome({
  onAddPropertyClick,
}: FrontpageWelcomeProps) {
  return (
    <Stack gap="xl" align="center">
      <Stack gap="md" align="center">
        <Group gap="md" align="center" wrap="nowrap">
          <IconHome size={56} color="var(--mantine-color-brandOrange-6)" />
          <Title order={2} style={{ textAlign: 'left' }}>
            <Trans>Welcome to Markku maintenance book</Trans>
          </Title>
        </Group>
        <Text size="lg" c="dimmed" maw={600} style={{ textAlign: 'center' }}>
          <Trans>
            Take care of your home easily. Markku helps you track your
            property's maintenance work, store important documents and maintain
            your home's value.
          </Trans>
        </Text>
      </Stack>

      <Card radius="md" bg="gray.0" w="100%" maw={700}>
        <Stack gap="lg">
          <Text size="md" fw={600}>
            <Trans>The maintenance book helps you:</Trans>
          </Text>

          <List
            spacing="md"
            size="md"
            icon={
              <IconSparkles
                size={20}
                color="var(--mantine-color-brandOrange-6)"
              />
            }
          >
            <List.Item>
              <Group gap="sm" wrap="nowrap">
                <div>
                  <Text fw={500}>
                    <Trans>Track annual maintenance</Trans>
                  </Text>
                  <Text size="sm" c="dimmed">
                    <Trans>
                      The annual calendar reminds you of seasonal maintenance
                      tasks
                    </Trans>
                  </Text>
                </div>
              </Group>
            </List.Item>

            <List.Item>
              <Group gap="sm" wrap="nowrap">
                <div>
                  <Text fw={500}>
                    <Trans>Maintain property information</Trans>
                  </Text>
                  <Text size="sm" c="dimmed">
                    <Trans>
                      A centralized place for all home information and images
                    </Trans>
                  </Text>
                </div>
              </Group>
            </List.Item>

            <List.Item>
              <Group gap="sm" wrap="nowrap">
                <div>
                  <Text fw={500}>
                    <Trans>Store documents</Trans>
                  </Text>
                  <Text size="sm" c="dimmed">
                    <Trans>
                      Warranties, receipts and important documents safe in one
                      place
                    </Trans>
                  </Text>
                </div>
              </Group>
            </List.Item>
          </List>
        </Stack>
      </Card>

      <Button
        size="lg"
        radius="md"
        color="brandOrange"
        onClick={onAddPropertyClick}
        w="100%"
        maw={400}
      >
        <Trans>Start by adding a property</Trans>
      </Button>
    </Stack>
  )
}
